import React from "react";
import UserRoleList from "./UserRoleList";

const UserRole = (props) => {
    return <UserRoleList  />
}

export default UserRole